<template lang="html">
  <span class="nav">
    <router-link :to="{ name: 'editor-list', params: {} }">Shows</router-link>
  </span>
</template>

<script>
export default {
  name: "NavBar"
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  bottom: 10px;
  left: 10px;
}
</style>
